import { LoadingSpinnerPanel } from '@frontend/web-react/components/Primitives/Loading/LoadingSpinnerPanel';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { validateSignUpSearch } from './-publicSearch';

const LazyWaitlist = lazy(() => import('./-wait-list').then((module) => ({ default: module.Waitlist })));

const WaitlistRouteComponent = () => (
  <Suspense fallback={<LoadingSpinnerPanel fullScreen />}>
    <LazyWaitlist />
  </Suspense>
);

export const Route = createFileRoute('/wait-list')({
  beforeLoad: async ({ context }) => {
    if (context.authentication?.isAuthenticated) {
      throw redirect({
        search: { tab: 'waiting_on_you' },
        to: '/app',
      });
    }
  },
  component: WaitlistRouteComponent,
  validateSearch: validateSignUpSearch,
});
